import { render, staticRenderFns } from "./Target.vue?vue&type=template&id=09ddecb8&"
import script from "./Target.vue?vue&type=script&lang=ts&"
export * from "./Target.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports